import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@projeccions-pdc/react-icon';
import NewSearch from './NewSearch';
import LibraryResultsContainer from './LibraryResultsContainer';
import UpdateFileController from './UpdateFileController';
import PromiseConsumer from './PromiseConsumer';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InputModal from './InputModal';
import LocalizedStrings from './localization.js';
import Drawer from '@material-ui/core/Drawer';
import FileDetailDrawer from './FileDetailDrawer';
import LibraryHome from './LibraryHome';
import HomeController from './HomeController';
import StoreController from '@projeccions-pdc/frontend-storage';
import { searchFiles, parseResults } from './SearchController';
import { cloneDeep } from 'lodash';
import Loader from '../Common/Loader';
import TagService from '../../apiclients/TagService';
import IdentityService from '../../apiclients/IdentityService';
import AppContext from '../../AppContext';

let queryCounters = {
    general: 0,
    tags: 0,
    groupID: 0,
    uploadedBy: 0,
    metadocument: 0,
    search: 0,
    searchUserSubs: 0,
};

const styles = (theme) => ({
    selectedTab: {
        backgroundColor: 'rgb(192, 0, 0)',
    },
    searchContainer: {
        display: 'inline-block',
        width: 'calc(100% - 30px)',
    },
    addBookmark: {
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        display: 'inline-block',
        width: '20px',
        verticalAlign: 'middle',
        padding: '5px',
        borderRadius: '4px',
        textAlign: 'center',
        cursor: 'pointer',
    },
});

let searchRefreshesCounter = 0;

let initialFilters = {
    tags: { max: -1, values: [] },
    groupID: { max: 1, values: [] },
    uploadedBy: { max: 1, values: [] },
    metadocument: { max: 1, values: [] },
    filename: { max: 1, values: [] },
    session: { max: 1, values: [] },
};

class LibraryFiles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            autocompleteResults: {},
            currentSearch: '',
            isAutocompleteLoading: false,
            activeFilters: cloneDeep(initialFilters),
            // tableData: undefined,
            // usersData: {},
            isList: true,
            mandatorySearchFileType: undefined,
            searchActiveItem: 0,
            showInputModal: false,
            currentFileId: '-1',

            searching: false,
        };

        //PRE FILTERS FOR THE PICKER
        if (props.pickerPreFilters) {
            if (props.pickerPreFilters.fileType !== undefined) {
                this.state.mandatorySearchFileType = props.pickerPreFilters.fileType;
                this.state.searchActiveItem = this.getTabFromFileType(props.pickerPreFilters.fileType);
            }
            if (props.pickerPreFilters.groupId !== undefined) {
                let group = {
                    title: LocalizedStrings.mandatoryGroupFilter,
                    type: 'groupID',
                    description: props.pickerPreFilters.groupId,
                    mandatory: true,
                };
                this.state.activeFilters.groupID.values.push(group);
            }
        }

        let appContext = new AppContext();
        let platformId = appContext.getPlatformId();
        let myInfo = appContext.getMyInfo();
        let userSub = myInfo ? myInfo.userSub : 'userAnonim';

        this._storeController = new StoreController(platformId, userSub);
        this._homeController = new HomeController(this, this._storeController);
        this._updateFileController = new UpdateFileController(this);
    }

    componentDidMount() {
        if (this.props.uploadedIds !== undefined) {
            this.showCurrentSession(this.props.sessionId, this.props.uploadedIds, this.props.uploadedFilters);
            this.props.currentSessionLoaded();
        }
    }

    static getDerivedStateFromProps(props, state) {
        let newState = null;
        if (props.pickerPreFilters) {
            if (
                props.pickerPreFilters.fileType !== undefined &&
                props.pickerPreFilters.fileType !==
                    (state.oldPickerPreFilters ? state.oldPickerPreFilters.fileType : state.oldPickerPreFilters)
            ) {
                let getTabFromFileType = (fileType) => {
                    if (fileType === 'file') {
                        return 0;
                    } else if (fileType === 'image') {
                        return 1;
                    } else if (fileType === 'video') {
                        return 2;
                    }
                };
                newState = Object.assign({}, newState, {
                    mandatorySearchFileType: props.pickerPreFilters.fileType,
                    searchActiveItem: getTabFromFileType(props.pickerPreFilters.fileType),
                    oldPickerPreFilters: props.pickerPreFilters,
                });
            }
            if (
                props.pickerPreFilters.groupId !== undefined &&
                props.pickerPreFilters.groupId !==
                    (state.oldPickerPreFilters ? state.oldPickerPreFilters.groupId : state.oldPickerPreFilters)
            ) {
                let group = {
                    title: LocalizedStrings.mandatoryGroupFilter,
                    type: 'groupID',
                    description: props.pickerPreFilters.groupId,
                    mandatory: true,
                };
                let activeFilters = Object.assign({}, state.activeFilters);
                activeFilters.groupID.values.push(group);
                newState = Object.assign({}, newState, {
                    activeFilters,
                    oldPickerPreFilters: props.pickerPreFilters,
                });
            }
        }
        return newState;
    }

    showFileDetail = (fileId) => {
        if (!this.props.isPicker) {
            this.setState({ currentFileId: fileId });
        }
    };

    closeDrawer = () => {
        this.setState({ currentFileId: undefined });
    };

    tagMultipleFiles = (ids, tags) => {
        let elements = [];
        ids.forEach((id) => {
            elements.push({
                fileId: id,
                tags,
            });
        });
        let promiseConsumer = new PromiseConsumer(4, elements, this.addTagsAction);
        promiseConsumer.consume();
    };

    addTagsAction = async (element, callback) => {
        let currentFile = this.getCurrentFile(element.fileId);
        let tags = element.tags;
        let response = this._updateFileController.handleAddTags(currentFile, tags);
        let tempState = response.tempState;
        let promise = response.promise;
        this.setCurrentFile(tempState);
        let newElement = await promise;
        this.setCurrentFile(newElement);

        if (callback) {
            callback();
        }
    };

    flagSharebleMultipleFiles = async (ids, shareable) => {
        for (let i = 0; i < ids.length; i++) {
            try {
                let currId = ids[i];
                let currentFile = this.getCurrentFile(currId);
                const oldShareable = currentFile.shareable;

                let newFile = cloneDeep(currentFile);
                newFile.shareable = shareable;
                this.setCurrentFile(newFile);

                let response = await this._updateFileController.onChangeShareable(currentFile, shareable, oldShareable);
                this.setCurrentFile(response);
            } catch (err) {
                console.log(err);
            }
        }
    };

    deleteMultipleFiles = (ids) => {
        let promiseConsumer = new PromiseConsumer(4, ids, this.deleteFileAction);
        promiseConsumer.consume();
    };

    deleteFileAction = async (fileId, callback) => {
        let currentFile = this.getCurrentFile(fileId);
        let response = await this._updateFileController.deleteFile(currentFile);
        if (response !== 'ko') {
            this.removeDeletedFile(currentFile.fileId);
        }
        if (callback) {
            callback();
        }
    };

    removeDeletedFile = (fileId) => {
        let stateTableName = `tableData${this.getFileTypeFromTab(this.state.searchActiveItem)}`;
        let currTable = this.state[stateTableName];
        let index = -1;
        for (let i = 0; i < currTable.length; i++) {
            if (currTable[i].fileId === fileId) {
                index = i;
            }
        }
        if (index !== -1) {
            const newData = currTable.slice();
            newData.splice(index, 1);
            this.setState({ [stateTableName]: newData });
        }
    };

    handleTabChange = (evt, value) => {
        this.setState({ searchActiveItem: value, currentFileId: '-1', currentSortId: undefined });
    };

    searchTags = (params) => {
        return TagService.getTags(params.tagPrefix);
    };

    searchUploader = (params) => {
        return IdentityService.searchUsers(params.nameBeginsWith);
    };

    searchGroup = (params) => {
        return IdentityService.searchGroups(params.nameBeginsWith);
    };

    handleSearchChange = (newValue, e) => {
        if (e.action !== 'input-change') return;
        let lastGroupId = ++queryCounters.general;
        let autocompleteQueries = [];
        let value = newValue;
        this.setState({ isAutocompleteLoading: true, currentSearch: value });
        if (value === '') {
            this.setState({ isAutocompleteLoading: false });
            return;
        }
        let newResults = {};
        let lastQueryIds = {};
        const activeFilters = this.state.activeFilters;

        let appContext = new AppContext();
        let myInfo = appContext.getMyInfo();

        if (activeFilters.tags.max === -1 || activeFilters.tags.values.length < activeFilters.tags.max) {
            autocompleteQueries.push(
                this.autocompleteElement(
                    this.searchTags,
                    { tagPrefix: value },
                    'tags',
                    LocalizedStrings.existingTags,
                    lastQueryIds,
                    newResults,
                    (element, type) => {
                        return { title: element, label: element, value: element, type: type };
                    },
                    (elements) => {
                        this.setState({ autocompleteResultsTags: elements });
                    }
                )
            );
        }
        if (myInfo.isAdmin) {
            if (activeFilters.uploadedBy.max === -1 || activeFilters.uploadedBy.values.length < activeFilters.uploadedBy.max) {
                autocompleteQueries.push(
                    this.autocompleteElement(
                        this.searchUploader,
                        { nameBeginsWith: value },
                        'uploadedBy',
                        LocalizedStrings.uploadedBy,
                        lastQueryIds,
                        newResults,
                        (element, type) => {
                            return {
                                title: element.name,
                                label: element.name,
                                value: element.name,
                                type: type,
                                description: element.userSub,
                            };
                        },
                        (elements) => {
                            this.setState({ autocompleteResultsUploadedBy: elements });
                        }
                    )
                );
            }
        } else {
            let elements = {
                name: LocalizedStrings.uploadedBy,
                results: [
                    {
                        title: LocalizedStrings.me,
                        value: LocalizedStrings.me,
                        label: LocalizedStrings.me,
                        type: 'uploadedBy',
                        description: myInfo.userSub,
                    },
                ],
            };
            this.setState({ autocompleteResultsUploadedBy: elements });
        }
        if (activeFilters.groupID.max === -1 || activeFilters.groupID.values.length < activeFilters.groupID.max) {
            autocompleteQueries.push(
                this.autocompleteElement(
                    this.searchGroup,
                    { nameBeginsWith: value },
                    'groupID',
                    LocalizedStrings.userGroup,
                    lastQueryIds,
                    newResults,
                    (element, type) => {
                        return { title: element.name, label: element.name, value: element.name, type: type, description: element.groupId };
                    },
                    (elements) => {
                        this.setState({ autocompleteResultsGroupId: elements });
                    }
                )
            );
        }
        // if (this.props.currentUserIsAdmin) {
        //     if (activeFilters.metadocument.max === -1 || activeFilters.metadocument.values.length < activeFilters.metadocument.max) {
        //         autocompleteQueries.push(
        //             this.autocompleteElement(searchMetadocument, { nameBeginsWith: value, language: this.props.currentLanguage }, 'metadocument', LocalizedStrings.metadocument, lastQueryIds, newResults, (element, type) => {
        //                 let name = '';
        //                 if (element.names[this.props.currentLanguage] !== undefined) {
        //                     name = element.names[this.props.currentLanguage];
        //                 } else {
        //                     name = element.names.default;
        //                 }
        //                 return { 'title': name, 'label': name, 'value': name, 'type': type, 'description': element.metadocumentId };
        //             }, (elements) => {
        //                 this.setState({ autocompleteResultsMetadocument: elements });
        //             })
        //         );
        //     }
        // }
        if (activeFilters.filename.max === -1 || activeFilters.filename.values.length < activeFilters.filename.max) {
            this.setState({
                autocompleteResultsFilename: {
                    name: LocalizedStrings.fileNameBeginsWith,
                    results: [{ title: value, label: value, value: value, type: 'filename' }],
                },
            });
        }

        Promise.all(autocompleteQueries).then(() => {
            if (lastGroupId !== queryCounters.general) return;
            this.setState({ isAutocompleteLoading: false });
        });
    };

    handleSelectedResult = (values) => {
        // console.log('handleSelectedResult', values);
        let newValues = cloneDeep(initialFilters);
        for (let i = 0; i < values.length; i++) {
            let result = values[i];
            if (result) {
                if (newValues[result.type].max === -1 || newValues[result.type].values.length < newValues[result.type].max) {
                    if (newValues[result.type].values.indexOf(result) === -1) {
                        newValues[result.type].values.push(result);
                    }
                }
            }
        }
        this.setState({ activeFilters: newValues, currentSearch: '' }, () => {
            this.search();
        });
    };

    autocompleteElement = (searchFunction, bodyParams, type, typeName, lastQueryIds, newResults, objectMapping, customSetState) => {
        lastQueryIds[type] = ++queryCounters[type];
        return searchFunction(bodyParams)
            .then((data) => {
                //console.log('autocompleteElement', data);
                if (lastQueryIds[type] !== queryCounters[type]) {
                    return;
                }
                let elements = { name: typeName, results: [] };
                if (data.items.length !== 0) {
                    elements.results = [];
                    data.items.forEach(function (element) {
                        elements.results.push(objectMapping(element, type));
                    });
                    elements.results = elements.results.slice(0, 10);
                    newResults[type] = elements;
                }
                customSetState(elements);
            })
            .catch((err) => {
                if (lastQueryIds[type] !== queryCounters[type]) return;
                console.log('err catch ' + type);
                console.log(err);
            });
    };

    loadFilesData = async (ids) => {
        let fileIds, imageIds, videoIds;
        fileIds = ids.file.map((obj) => obj.fileId);
        imageIds = ids.image.map((obj) => obj.fileId);
        videoIds = ids.video.map((obj) => obj.fileId);

        this.setState({ searching: true });

        // console.log('loading session data', fileIds, imageIds, videoIds);

        let queries = [];
        queries.push(
            parseResults(fileIds, 'file').then((newState) => {
                // console.log('loadFilesData result file', newState);
                this.setState(newState);
            })
        );
        queries.push(
            parseResults(imageIds, 'image').then((newState) => {
                // console.log('loadFilesData result image', newState);
                this.setState(newState);
            })
        );
        queries.push(
            parseResults(videoIds, 'video').then((newState) => {
                // console.log('loadFilesData result video', newState);
                this.setState(newState);
            })
        );
        return Promise.all(queries).then(() => {
            // console.log('all loads finished');
            this.setState({ searching: false });
        });
    };

    search = async (loadMoreFromLastKey, loadMoreFileType) => {
        if ([1, 2].indexOf(this.state.activeItem) === -1) {
            this.setState({ activeItem: 1 });
        }

        let fileType = this.state.searchActiveItem;
        if (fileType === 0) {
            fileType = 'file';
        } else if (fileType === 1) {
            fileType = 'image';
        } else if (fileType === 2) {
            fileType = 'video';
        } else {
            //session ?
            fileType = undefined;
        }

        let tags = [];
        this.state.activeFilters.tags.values.length > 0
            ? this.state.activeFilters.tags.values.forEach((tagObj) => {
                  tags.push(tagObj.title);
              })
            : (tags = undefined);

        let filenameBeginsWith =
            this.state.activeFilters.filename.values.length > 0 ? this.state.activeFilters.filename.values[0].title : undefined;
        let uploadedBy =
            this.state.activeFilters.uploadedBy.values.length > 0 ? this.state.activeFilters.uploadedBy.values[0].description : undefined;
        let groupId =
            this.state.activeFilters.groupID.values.length > 0 ? this.state.activeFilters.groupID.values[0].description : undefined;
        let metadocumentId =
            this.state.activeFilters.metadocument.values.length > 0
                ? { objectType: 'm', objectId: this.state.activeFilters.metadocument.values[0].description }
                : undefined;
        let session =
            this.state.activeFilters.session && this.state.activeFilters.session.values.length > 0
                ? this.state.activeFilters.session.values[0].value
                : undefined;

        if (
            tags === undefined &&
            filenameBeginsWith === undefined &&
            uploadedBy === undefined &&
            groupId === undefined &&
            metadocumentId === undefined &&
            session === undefined
        ) {
            this.setState({ tableDatafile: undefined, tableDataimage: undefined, tableDatavideo: undefined });
            return;
        }

        // if (!this.props.currentUserIsAdmin) {
        //     if (groupId === undefined) {
        //         return;
        //     }
        // }

        let lastQueryId = ++queryCounters.search;
        this.setState({ currentSortId: undefined, searching: true });
        try {
            let queries = [];

            let query = tags ? `${tags.join(' ')} ` : '';
            query += session ? session + ' ' : '';
            query += filenameBeginsWith ? filenameBeginsWith : '';

            let params = {
                query,
                author: uploadedBy,
                groupId: groupId,
                resourceType: 'file',
                //resourceSubtype: fileType,
                lastKey: loadMoreFromLastKey,
            };
            // console.log('params', params)
            if (!loadMoreFileType || loadMoreFileType === 'file') {
                if (this.state.mandatorySearchFileType === undefined || this.state.mandatorySearchFileType === 'file') {
                    params.resourceSubtype = 'file';
                    queries.push(
                        searchFiles(
                            cloneDeep(params),
                            queryCounters,
                            lastQueryId,
                            loadMoreFromLastKey,
                            this.state.tableDatafile,
                            'file'
                        ).then((response) => {
                            //  console.log('search file processed result', response);
                            this.setState(response);
                        })
                    );
                }
            }
            if (!loadMoreFileType || loadMoreFileType === 'image') {
                if (this.state.mandatorySearchFileType === undefined || this.state.mandatorySearchFileType === 'image') {
                    params.resourceSubtype = 'image';
                    queries.push(
                        searchFiles(
                            cloneDeep(params),
                            queryCounters,
                            lastQueryId,
                            loadMoreFromLastKey,
                            this.state.tableDataimage,
                            'image'
                        ).then((response) => {
                            //  console.log('search image processed result', response);
                            this.setState(response);
                        })
                    );
                }
            }
            if (!loadMoreFileType || loadMoreFileType === 'video') {
                if (this.state.mandatorySearchFileType === undefined || this.state.mandatorySearchFileType === 'video') {
                    params.resourceSubtype = 'video';
                    queries.push(
                        searchFiles(
                            cloneDeep(params),
                            queryCounters,
                            lastQueryId,
                            loadMoreFromLastKey,
                            this.state.tableDatavideo,
                            'video'
                        ).then((response) => {
                            //  console.log('search video processed result', response);
                            this.setState(response);
                        })
                    );
                }
            }
            return Promise.all(queries).then(() => {
                let tab = 'file';
                let tabs = ['file', 'image', 'video'];
                let found = false;
                for (let i = 0; i < tabs.length && found === false; i++) {
                    let fileType = tabs[i];
                    if (this.state[`tableData${fileType}`] && this.state[`tableData${fileType}`].length > 0) {
                        tab = fileType;
                        found = true;
                    }
                }

                //FIXME:
                let newSearchActiveItem = this.getTabFromFileType(tab);
                this.setState({ searching: false, searchActiveItem: newSearchActiveItem });
            });
        } catch (err) {
            console.log(err);
        }
    };

    handleLoadMoreData = () => {
        this.search(
            this.state[`lastKey${this.getFileTypeFromTab(this.state.searchActiveItem)}`],
            this.getFileTypeFromTab(this.state.searchActiveItem)
        );
    };

    getSessionFilterObj = (sessionId) => {
        let sessions = this._homeController.listAllSessions(true);
        let ses = sessions.find((curr) => {
            return curr.id === sessionId;
        });
        return {
            label: `session: ${new Date(ses.date).toLocaleString()}`,
            title: ses.date,
            type: 'session',
            value: ses.id,
        };
    };

    showCurrentSession = (sessionId, uploadedIds, result /*group*/) => {
        //TODO: testejar mes a fons si NO es admin
        // console.log('showCurrentSession', uploadedIds);
        let newState;
        let appContext = new AppContext();
        let myInfo = appContext.getMyInfo();
        if (result && myInfo.isAdmin !== true) {
            console.log(this.state.activeFilters, 'groupID', result);
            if (
                this.state.activeFilters['groupID'].max === -1 ||
                this.state.activeFilters['groupID'].values.length < this.state.activeFilters['groupID'].max
            ) {
                if (this.state.activeFilters['groupID'].values.indexOf(result) === -1) {
                    let activeFilters = Object.assign({}, this.state.activeFilters);
                    activeFilters['groupID'].values.push({
                        type: 'groupID',
                        description: result.groupId,
                        label: result.name,
                        title: result.name,
                        value: result.name,
                    });
                    activeFilters.session.values = [this.getSessionFilterObj(sessionId)];
                    newState = { activeFilters, currentSearch: '' };
                }
            }
        } else {
            let activeFilters = cloneDeep(initialFilters);
            activeFilters.session.values = [this.getSessionFilterObj(sessionId)];
            newState = {
                activeFilters,
                currentSearch: '',
            };
        }
        this.setState(newState, () => {
            searchRefreshesCounter = 0;
            this.loadSession(uploadedIds);
        });
    };

    loadSession = (uploadedIds) => {
        let searchActiveItem = '';
        if (uploadedIds.file.length !== 0) {
            searchActiveItem = 0;
        } else if (uploadedIds.image.length !== 0) {
            searchActiveItem = 1;
        } else if (uploadedIds.video.length !== 0) {
            searchActiveItem = 2;
        }
        this.setState({ searchActiveItem: searchActiveItem, currentFileId: '-1' }, () => {
            this.loadFilesData(uploadedIds).then(() => {
                let file, image, video;
                file = this.isSessionFileTypeLoaded(uploadedIds, 'file');
                image = this.isSessionFileTypeLoaded(uploadedIds, 'image');
                video = this.isSessionFileTypeLoaded(uploadedIds, 'video');

                // console.log('heyyyyuyyy')
                if (file === false || image === false || video === false) {
                    // console.log('heyyyyuyyy2')
                    setTimeout(() => {
                        // console.log('heyyyyuyyy3')
                        searchRefreshesCounter++;
                        this.loadSession(uploadedIds);
                    }, 5000);
                }
            });
        });
    };

    isSessionFileTypeLoaded = (uploadedIds, fileType) => {
        let dataItems = this.state[`tableData${fileType}`];
        let lastKey = this.state[`lastKey${fileType}`];

        let currentIds = uploadedIds[fileType].map((file) => {
            return file.fileId;
        });
        let coincidents = dataItems.filter((item) => {
            return currentIds.indexOf(item.fileId) >= 0;
        });

        if (currentIds.length !== coincidents.length && lastKey === undefined && searchRefreshesCounter < 10) {
            return false;
        }
        return true;
    };

    setListLayout = () => {
        this.setState({ isList: true });
    };

    setGridLayout = () => {
        this.setState({ isList: false });
    };

    handleCloseInputModal = () => {
        this.setState({ showInputModal: false });
    };

    handleConfirmInputModal = (bookmarkName) => {
        this._homeController.addBookmark(bookmarkName, this.state.activeFilters);
    };

    handlePickFiles = (files) => {
        this._homeController.processPickedFiles(files);
        this.props.onPickFiles(files);
    };

    addCurrentBookmark = () => {
        this.setState({ showInputModal: true });
    };

    loadBookmark = (bookmark) => {
        let newActiveFilters = Object.assign({}, bookmark.filters);
        let currActiveFilters = Object.assign({}, this.state.activeFilters);
        Object.keys(currActiveFilters).forEach((filterKey) => {
            let auxFilters = currActiveFilters[filterKey];
            auxFilters.values.forEach((filter) => {
                if (filter.mandatory === true) {
                    newActiveFilters[filterKey].values = newActiveFilters[filterKey].values.filter(
                        (bookmark) => bookmark.name !== filter.name
                    );
                    if (auxFilters.max === -1 || auxFilters.values.length < auxFilters.max) {
                        newActiveFilters[filterKey].values.push(filter);
                    } else {
                        newActiveFilters[filterKey].values = [];
                        newActiveFilters[filterKey].values.push(filter);
                    }
                }
            });
        });

        this.setState({ activeFilters: newActiveFilters }, () => {
            this.search();
        });
        return;
    };

    loadSessionFromHome = (sessionId) => {
        // console.log('load session ' + sessionId);

        let session = this.getSessionFilterObj(sessionId);
        let clone = cloneDeep(this.parseProps(this.state.activeFilters));
        clone.push(session);
        this.handleSelectedResult(clone);
    };

    parseProps = (activeFilters) => {
        let newValues = [];
        Object.keys(activeFilters).forEach((categoryKey) => {
            if (activeFilters[categoryKey].values) {
                activeFilters[categoryKey].values.forEach((value) => {
                    newValues.push(value);
                });
            }
        });
        return newValues;
    };

    shouldDisplayResults = () => {
        return this.getTableData('file') || this.getTableData('image') || this.getTableData('video');
    };

    getTableData = (fileType) => {
        return this.state[`tableData${fileType}`];
    };

    getTableDataCount = (fileType) => {
        if (this.getTableData(fileType)) {
            return this.getTableData(fileType).length;
        }
        return 0;
    };

    getTableDataCountFromTab = (tabIndex) => {
        return this.getTableDataCount(this.getFileTypeFromTab(tabIndex));
    };

    getFileTypeFromTab = (tabIndex) => {
        if (tabIndex === 0) {
            return 'file';
        } else if (tabIndex === 1) {
            return 'image';
        } else if (tabIndex === 2) {
            return 'video';
        }
    };

    getTabFromFileType = (fileType) => {
        if (fileType === 'file') {
            return 0;
        } else if (fileType === 'image') {
            return 1;
        } else if (fileType === 'video') {
            return 2;
        }
    };

    getTabLabel = (name, fileType) => {
        let canLoadMore = this.state[`lastKey${fileType}`] ? true : false;
        return `${name}(${this.getTableDataCount(fileType)}${canLoadMore ? '+' : ''})`;
    };

    shouldShowTab = (fileType) => {
        if (this.state.mandatorySearchFileType && this.state.mandatorySearchFileType === fileType) {
            return true;
        } else if (this.state.mandatorySearchFileType && this.state.mandatorySearchFileType !== fileType) {
            return false;
        } else {
            return true;
        }
    };

    getCurrentFile = (fileId) => {
        if (!fileId) {
            fileId = this.state.currentFileId;
        }
        let stateTableName = `tableData${this.getFileTypeFromTab(this.state.searchActiveItem)}`;
        let currentFile = this.state[stateTableName].find((element) => {
            return element.fileId === fileId;
        });

        return currentFile;
    };

    setCurrentFile = (currentFile) => {
        let stateTableName = `tableData${this.getFileTypeFromTab(this.state.searchActiveItem)}`;
        const nextFiles = this.state[stateTableName].map((file) => {
            if (file.fileId === currentFile.fileId) {
                return Object.assign({}, currentFile);
            } else {
                return file;
            }
        });
        this.setState({ [stateTableName]: nextFiles });
    };

    render() {
        let filterCount = 0;
        Object.keys(this.state.activeFilters).forEach((categoryKey) => {
            if (this.state.activeFilters[categoryKey].values) {
                filterCount += this.state.activeFilters[categoryKey].values.length;
            }
        });
        let currentFile;

        let tableData = this.state[`tableData${this.getFileTypeFromTab(this.state.searchActiveItem)}`];
        let usersData = this.state[`usersData${this.getFileTypeFromTab(this.state.searchActiveItem)}`];
        let partialData = this.state[`lastKey${this.getFileTypeFromTab(this.state.searchActiveItem)}`];
        if (tableData && tableData.length > 0) {
            currentFile = tableData.find((element) => {
                return element.fileId === this.state.currentFileId;
            });

            for (let i = 0; i < tableData.length; i++) {
                // Use last available date as date created
                if (tableData[i].lastUploaded !== undefined) {
                    tableData[i].dateCreated = tableData[i].lastUploaded;
                } else if (tableData[i].lastUpdated !== undefined) {
                    tableData[i].dateCreated = tableData[i].lastUpdated;
                }
            }
        }
        return (
            <div data-id="library-files-container">
                <Drawer anchor="right" open={currentFile ? true : false} onClose={this.closeDrawer}>
                    <FileDetailDrawer
                        isDrawer={true}
                        currentFile={currentFile}
                        closeDrawer={this.closeDrawer}
                        usersData={usersData}
                        setCurrentFile={this.setCurrentFile}
                        removeDeletedFile={this.removeDeletedFile}
                        notify={this.props.notify}
                        openContent={this.props.openContent}
                        openFileViewer={this.props.openFileViewer}
                    />
                </Drawer>
                <div className={this.props.classes.searchContainer} data-id="library-files-searchContainer">
                    <NewSearch
                        isMulti={true}
                        placeholder={LocalizedStrings.searchPlaceholder}
                        isLoading={this.state.isAutocompleteLoading}
                        value={this.state.currentSearch}
                        onSearchChange={this.handleSearchChange}
                        onResultSelect={this.handleSelectedResult}
                        firstResults={this.state.autocompleteResultsTags}
                        secondResults={this.state.autocompleteResultsFilename}
                        thirdResults={this.state.autocompleteResultsUploadedBy}
                        fourthResults={this.state.autocompleteResultsGroupId}
                        fifthResults={this.state.autocompleteResultsMetadocument}
                        activeFilters={this.parseProps(this.state.activeFilters)}
                    />
                </div>
                {filterCount > 0 ? (
                    this.state.searching === false ? (
                        <div className={this.props.classes.addBookmark}>
                            <IconButton name="fa-star" primaryColor={'#fff'} secondaryColor={'#000'} onClick={this.addCurrentBookmark} />
                        </div>
                    ) : (
                        <div style={{ display: 'inline-block', padding: '5px' }}>
                            <Loader loading={true} />
                        </div>
                    )
                ) : (
                    ''
                )}
                <InputModal
                    open={this.state.showInputModal}
                    handleClose={this.handleCloseInputModal}
                    handleYes={this.handleConfirmInputModal}
                />

                {this.shouldDisplayResults() ? (
                    <div>
                        <div style={{ position: 'relative' }}>
                            <div style={{ display: 'inline-block' }}>
                                <Tabs
                                    data-id="library-files-tabs"
                                    value={this.state.searchActiveItem}
                                    onChange={this.handleTabChange}
                                    classes={{ indicator: this.props.classes.selectedTab }}
                                >
                                    <Tab
                                        data-id="library-files-tab-file"
                                        label={this.getTabLabel(LocalizedStrings.files, 'file')}
                                        disabled={!this.shouldShowTab('file')}
                                    />
                                    <Tab
                                        data-id="library-files-tab-image"
                                        label={this.getTabLabel(LocalizedStrings.images, 'image')}
                                        disabled={!this.shouldShowTab('image')}
                                    />
                                    <Tab
                                        data-id="library-files-tab-video"
                                        label={this.getTabLabel(LocalizedStrings.videos, 'video')}
                                        disabled={!this.shouldShowTab('video')}
                                    />
                                </Tabs>
                            </div>
                            <div style={{ position: 'absolute', top: '50%', right: 0, transform: 'translate(0,-50%)' }}>
                                <IconButton
                                    data-id="library-files-table-view"
                                    name="fa-bars"
                                    size="20px"
                                    onClick={this.setListLayout}
                                    primaryColor="#000"
                                    secondaryColor="#9b9b9b"
                                />{' '}
                                <IconButton
                                    data-id="library-files-grid-view"
                                    name="fa-th-large"
                                    size="20px"
                                    onClick={this.setGridLayout}
                                    primaryColor="#000"
                                    secondaryColor="#9b9b9b"
                                />
                            </div>
                        </div>
                        {this.getTableDataCountFromTab(this.state.searchActiveItem) > 0 ? (
                            <LibraryResultsContainer
                                tableData={tableData}
                                usersData={usersData}
                                partialData={partialData}
                                handleLoadMoreData={this.handleLoadMoreData}
                                isList={this.state.isList}
                                tagMultipleFiles={this.tagMultipleFiles}
                                flagSharebleMultipleFiles={this.flagSharebleMultipleFiles}
                                showFileDetail={this.showFileDetail}
                                isPicker={this.props.isPicker}
                                onPickFiles={this.handlePickFiles}
                                deleteMultipleFiles={this.deleteMultipleFiles}
                                multipleChoice={this.props.pickerPreFilters ? this.props.pickerPreFilters.multipleChoice : true}
                            />
                        ) : (
                            <div style={{ textAlign: 'center' }}>{LocalizedStrings.noResults}</div>
                        )}
                    </div>
                ) : (
                    <LibraryHome
                        handleDeleteBookmark={this.removeBookmark}
                        handleLoadBookmark={this.loadBookmark}
                        handleLoadSession={this.loadSessionFromHome}
                        isPicker={this.props.isPicker}
                        pickerPreFilters={this.props.pickerPreFilters}
                        onPickFiles={this.props.onPickFiles}
                    />
                )}
            </div>
        );
    }
}
LibraryFiles.propTypes = {
    isPicker: PropTypes.bool.isRequired,
    pickerPreFilters: PropTypes.object,
    classes: PropTypes.object.isRequired,
    onPickFiles: PropTypes.func,
    uploadedIds: PropTypes.object,
    uploadedFilters: PropTypes.object,
    currentSessionLoaded: PropTypes.func.isRequired,
    sessionId: PropTypes.string,
    notify: PropTypes.func,
    openContent: PropTypes.func,
    openFileViewer: PropTypes.func,
};

export default withStyles(styles)(LibraryFiles);
